/* unplugin-vue-components disabled */import { render } from "./ShareUserRule.vue?vue&type=template&id=7b8b56ca&scoped=true"
import script from "./ShareUserRule.vue?vue&type=script&lang=js"
export * from "./ShareUserRule.vue?vue&type=script&lang=js"

import "./ShareUserRule.vue?vue&type=style&index=0&id=7b8b56ca&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8b56ca"]])

export default __exports__